export const blogPosts = [
  {
    slug: 'why-i-chose-mern',
    title: 'Why I Chose the MERN Stack',
    excerpt: 'Everyone has an opinion on what stack to learn first. Here\'s why I picked MERN and what I\'d tell my past self.',
    tags: ['Engineering', 'Personal'],
    date: 'June 20, 2026',
    content: `
# Why I Chose the MERN Stack

Everyone has an opinion on what stack to learn first. Here's why I picked MERN and what I'd tell my past self.

## The Decision

When I started learning web development, the options were overwhelming. React vs Vue vs Angular. SQL vs NoSQL. REST vs GraphQL.

I picked MERN because it's JavaScript all the way down. One language, full stack. That matters when you're just starting out.

## What I Learned

The real value wasn't in React or Express individually. It was in understanding how the pieces connect — how a request flows from the browser through an API to a database and back.

Once you understand that flow, switching frameworks becomes trivial. The concepts transfer.

## What I'd Tell My Past Self

Stop tutorial hopping. Pick a project, build it, break it, fix it. You learn more from one real project than from ten tutorials.

The stack doesn't matter as much as the depth you go into it.
    `.trim()
  },
  {
    slug: 'what-running-acm-taught-me',
    title: 'What Running ACM Taught Me About Leadership',
    excerpt: 'Being ACM Chapter President wasn\'t about organizing events. It was about learning how to get things done with people who don\'t report to you.',
    tags: ['Personal', 'Career'],
    date: 'June 10, 2026',
    content: `
# What Running ACM Taught Me About Leadership

Being ACM Chapter President wasn't about organizing events. It was about learning how to get things done with people who don't report to you.

## The Reality of Student Leadership

Nobody owes you anything. The people on your team are volunteers with their own priorities, their own deadlines, their own lives. You can't demand, you can only make it worth showing up.

That's harder than it sounds.

## What Actually Works

Clarity beats enthusiasm every time. A clear brief, a clear deadline, and a clear definition of done gets more done than five motivational speeches.

The second thing: show up first. If you're asking people to give their time, give yours first and give it visibly.

## The Lesson That Stuck

Ownership is contagious. When one person genuinely owns a task, it raises the bar for everyone around them. The opposite is also true.

Build a team of owners, not assignees.
    `.trim()
  },
  {
    slug: 'building-in-public-is-hard',
    title: 'Building in Public Is Harder Than It Looks',
    excerpt: 'The idea sounds great: share your work, grow your audience, stay accountable. The reality is messier.',
    tags: ['Personal', 'Engineering'],
    date: 'May 28, 2026',
    content: `
# Building in Public Is Harder Than It Looks

The idea sounds great: share your work, grow your audience, stay accountable. The reality is messier.

## The Gap Between Idea and Execution

Most things look bad before they look good. Sharing the early stages means sharing that ugly middle phase — the version that barely works, the UI that looks broken, the feature that's half done.

The instinct is to wait until it's ready. But "ready" is a moving target.

## What I Noticed

The posts that perform are rarely the polished ones. They're the honest ones. The "this broke and here's why" posts. The "I spent a week on this and it taught me nothing useful" posts.

People relate to the mess, not the highlight reel.

## The Actual Hard Part

Consistency. Not just in posting, but in building. Showing up when nobody's watching, when the engagement is zero, when the project feels pointless.

That's the part they don't tell you about.
    `.trim()
  }
];

export const getAllTags = () => {
  const tags = blogPosts.flatMap(p => p.tags);
  return ['All', ...new Set(tags)];
};

export const getPostBySlug = (slug) => blogPosts.find(p => p.slug === slug);